import { createFileRoute } from "@tanstack/react-router";
import { ReservaPruebaPage } from "@/components/booking/ReservaPruebaPage";

export const Route = createFileRoute("/reserva-prueba/$code")({
  head: ({ params }) => ({
    meta: [
      { title: `Estado de tu reserva ${params.code} | Mostrando México` },
      {
        name: "description",
        content:
          "Consulta el estado de tu reserva en Mostrando México: apartada, en verificación o confirmada y pagada.",
      },
      { property: "og:title", content: "Estado de tu reserva | Mostrando México" },
      {
        property: "og:description",
        content: "Sigue la confirmación y el pago de tu experiencia en México.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: ReservaPruebaPage,
});
